// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"rR4Be","rc-tabs-tab-active":"EAD4z","input-suffix":"_14P+P","nav-item":"IamGf","location-info-card":"+oN6E","location-title":"ZNMf4","location-info":"Utg9Z"};